import request from '../utils/request';

/**
 * Admin-side wrapper for /api/v1/admin/sms-outreach (guest SMS pipeline
 * analytics + Airflow control). All reads are available to any admin-portal
 * user; trigger/pause require role=admin server-side.
 */
const BASE = '/admin/sms-outreach';

export const SmsOutreachService = {
  summary: async (params) => (await request.get(`${BASE}/summary`, { params })).data?.summary,
  daily: async (params) => (await request.get(`${BASE}/daily`, { params })).data,
  runs: async (params) => (await request.get(`${BASE}/runs`, { params })).data?.runs || [],
  run: async (runId) => (await request.get(`${BASE}/runs/${encodeURIComponent(runId)}`)).data?.run,
  messages: async (params) => (await request.get(`${BASE}/messages`, { params })).data,
  failures: async (params) => (await request.get(`${BASE}/failures`, { params })).data?.failures,
  conversion: async (params) => (await request.get(`${BASE}/conversion`, { params })).data?.conversion,

  airflowStatus: async () => (await request.get(`${BASE}/airflow/status`)).data,
  airflowTrigger: async ({ mode, note }) => (await request.post(`${BASE}/airflow/trigger`, { mode, note })).data,
  airflowPause: async (paused) => (await request.post(`${BASE}/airflow/pause`, { paused })).data,
  airflowTaskLog: async (runId, taskId, tryNumber = 1) =>
    (
      await request.get(
        `${BASE}/airflow/runs/${encodeURIComponent(runId)}/tasks/${encodeURIComponent(taskId)}/log`,
        { params: { try: tryNumber } }
      )
    ).data?.log,
};

export default SmsOutreachService;
